import React, { FunctionComponent, useEffect } from "react";
import { GameCodes, IdType } from "../type";
import GameProvider from "../game-provider";
import { NotFoundView } from "./not-found";
import { Spinner } from "../components/spinner";
import { useFetchRoundHistory, useTypeAndId } from "../hooks";
import { useTranslationReducer } from "../context/TranslationContext";

export const RoundHistoryView: FunctionComponent = () => {
  const { gameCode, type, id } = useTypeAndId();
  const roundHistory = useFetchRoundHistory({
    gameCode,
    type,
    id,
  });
  const translationReducer = useTranslationReducer();

  useEffect(() => {
    if (roundHistory) {
      translationReducer(roundHistory.lang);
    }
  }, [translationReducer, roundHistory]);

  if (type === IdType.Unknown || gameCode === GameCodes.Unknown || !id) {
    return <NotFoundView />;
  }

  if (!roundHistory) return <Spinner />;

  const historyComponent = GameProvider.getGameRoundHistoryView(gameCode);

  return (
    <div className={gameCode}>
      {React.createElement(historyComponent, {
        key: "round-history-component",
        type,
        id,
        roundHistory,
      })}
    </div>
  );
};
